import { Pipe, PipeTransform } from '@angular/core';
import { RoleEnum } from '../../interfaces/application';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {

  transform(role: RoleEnum | string | null | undefined): string {
    if (!role) {
      return '';
    }

    const roles: Record<string, string> = {
      [RoleEnum.MASTER]: 'Master',
      [RoleEnum.ADMIN]: 'Administrador',
      [RoleEnum.FINANCIAL]: 'Financeiro',
      [RoleEnum.JURIDICAL]: 'Jurídico',
      [RoleEnum.VIEWER]: 'Visualizador',
      [RoleEnum.OPERATOR]: 'Operador',
      [RoleEnum.MARKET]: 'Market',
      [RoleEnum.TELEMARKETING]: 'Telemarketing',
      [RoleEnum.AFFILIATE]: 'Afiliado',
    };

    return roles[role] || role;
  }

}
